import { useEffect, useState } from "react";
import authServices from "app/services/auth-services";

const usePlanDetails = (id) => {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const response = await authServices.planDetails(id);
        setPlan(response);
        setLoading(false);
      } catch (err) {
        setError("Plan not found");
        setLoading(false);
      }
    };
    fetchPlan();
  }, [id]);

  return { plan, loading, error };
};

export default usePlanDetails;
